import { Box } from "@mui/material";

import { activityCategoryStyle, borderRadius } from "../theme/designTokens";
import { ActivityGoalKind } from "./activityGoalKinds";

// Renders a category's existing SVG icon (the same assets the Aktivitätenverlauf
// tab uses) inside a soft rounded tile tinted with the category color.
export const ActivityCategoryIcon = ({ kind, size = 30 }: { kind: ActivityGoalKind; size?: number }) => {
  const style = activityCategoryStyle[kind];

  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: borderRadius.md,
        backgroundColor: style.bg,
        display: "grid",
        placeItems: "center",
        flex: `0 0 ${size}px`,
      }}
    >
      <Box
        component="img"
        src={`/images/${style.icon}-icon.svg`}
        alt=""
        width={Math.round(size * 0.62)}
        height={Math.round(size * 0.62)}
      />
    </Box>
  );
};
